import {styled} from '@mui/material';
import {Button} from '../Button/Button';

export const AuthButton = styled(Button)(({theme, ...props}) => ({
  background: props.primary ? '#5C87FF' : '#FFFFFFB3',
  border: `1px solid ${props.primary ? '#0000001A' : '#FFFFFF80'}`,
  color: props.primary ? '#FFFFFF' : '#000000',
  borderRadius: theme.typography.pxToRem(12),
  width: '100%',
  padding: theme.typography.pxToRem(10),
  fontSize: theme.typography.pxToRem(16),
  lineHeight: '1.4',
  fontWeight: '500',
  cursor: 'pointer',
  '&:hover': {
    background: props.primary ? '#5C87FFee' : '#FFFFFFB3',
  },
}));
